var chunkMapping = {
	"65": [
		40065
	],
	"92": [
		4527,
		15033,
		20840,
		79255
	],
	"307": [
		616,
		13617,
		20916,
		28061,
		28998,
		33362,
		36426,
		54686,
		67000,
		72398,
		91099
	]
};
var idToExternalAndNameMapping = {
	"616": [
		"default",
		"./useCookies",
		75702
	],
	"4527": [
		"default",
		"./MobileDrawer",
		75702
	],
	"13617": [
		"default",
		"./CustomError404",
		75702
	],
	"15033": [
		"default",
		"./useAuth",
		75702
	],
	"20840": [
		"default",
		"./useSessionStorage",
		75702
	],
	"20916": [
		"default",
		"./eventBus",
		75702
	],
	"28061": [
		"default",
		"./getAPIURL",
		75702
	],
	"28998": [
		"default",
		"./globalStorage",
		75702
	],
	"33362": [
		"default",
		"./i18n",
		75702
	],
	"36426": [
		"default",
		"./ErrorBoundary",
		75702
	],
	"40065": [
		"default",
		"./RemoteComponent",
		75702
	],
	"54686": [
		"default",
		"./permissionUtils",
		75702
	],
	"67000": [
		"default",
		"./NetworkOps",
		75702
	],
	"72398": [
		"default",
		"./useMobileDetection",
		75702
	],
	"79255": [
		"default",
		"./Themes",
		75702
	],
	"91099": [
		"default",
		"./Loader",
		75702
	]
};
var idToRemoteMap = {
	"616": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE"
		}
	],
	"4527": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE"
		}
	],
	"13617": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE"
		}
	],
	"15033": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE"
		}
	],
	"20840": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE"
		}
	],
	"20916": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE"
		}
	],
	"28061": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE"
		}
	],
	"28998": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE"
		}
	],
	"33362": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE"
		}
	],
	"36426": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE"
		}
	],
	"40065": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE"
		}
	],
	"54686": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE"
		}
	],
	"67000": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE"
		}
	],
	"72398": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE"
		}
	],
	"79255": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE"
		}
	],
	"91099": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"616": {
		"shareScope": "default",
		"name": "./useCookies",
		"externalModuleId": 75702,
		"remoteName": "OP_WEB_COMMON_SERVICE"
	},
	"4527": {
		"shareScope": "default",
		"name": "./MobileDrawer",
		"externalModuleId": 75702,
		"remoteName": "OP_WEB_COMMON_SERVICE"
	},
	"13617": {
		"shareScope": "default",
		"name": "./CustomError404",
		"externalModuleId": 75702,
		"remoteName": "OP_WEB_COMMON_SERVICE"
	},
	"15033": {
		"shareScope": "default",
		"name": "./useAuth",
		"externalModuleId": 75702,
		"remoteName": "OP_WEB_COMMON_SERVICE"
	},
	"20840": {
		"shareScope": "default",
		"name": "./useSessionStorage",
		"externalModuleId": 75702,
		"remoteName": "OP_WEB_COMMON_SERVICE"
	},
	"20916": {
		"shareScope": "default",
		"name": "./eventBus",
		"externalModuleId": 75702,
		"remoteName": "OP_WEB_COMMON_SERVICE"
	},
	"28061": {
		"shareScope": "default",
		"name": "./getAPIURL",
		"externalModuleId": 75702,
		"remoteName": "OP_WEB_COMMON_SERVICE"
	},
	"28998": {
		"shareScope": "default",
		"name": "./globalStorage",
		"externalModuleId": 75702,
		"remoteName": "OP_WEB_COMMON_SERVICE"
	},
	"33362": {
		"shareScope": "default",
		"name": "./i18n",
		"externalModuleId": 75702,
		"remoteName": "OP_WEB_COMMON_SERVICE"
	},
	"36426": {
		"shareScope": "default",
		"name": "./ErrorBoundary",
		"externalModuleId": 75702,
		"remoteName": "OP_WEB_COMMON_SERVICE"
	},
	"40065": {
		"shareScope": "default",
		"name": "./RemoteComponent",
		"externalModuleId": 75702,
		"remoteName": "OP_WEB_COMMON_SERVICE"
	},
	"54686": {
		"shareScope": "default",
		"name": "./permissionUtils",
		"externalModuleId": 75702,
		"remoteName": "OP_WEB_COMMON_SERVICE"
	},
	"67000": {
		"shareScope": "default",
		"name": "./NetworkOps",
		"externalModuleId": 75702,
		"remoteName": "OP_WEB_COMMON_SERVICE"
	},
	"72398": {
		"shareScope": "default",
		"name": "./useMobileDetection",
		"externalModuleId": 75702,
		"remoteName": "OP_WEB_COMMON_SERVICE"
	},
	"79255": {
		"shareScope": "default",
		"name": "./Themes",
		"externalModuleId": 75702,
		"remoteName": "OP_WEB_COMMON_SERVICE"
	},
	"91099": {
		"shareScope": "default",
		"name": "./Loader",
		"externalModuleId": 75702,
		"remoteName": "OP_WEB_COMMON_SERVICE"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}